import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Row>
        <Col sm="4" className="text-left">
          <h5>{t(`FOOTER.HEAD1`)}</h5>
          <ul className="list-unstyled">
            <li>
              <Link to="/imprint">{t(`IMPRINT.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/privacy">{t(`PRIVACY.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/terms">{t(`TERMS_AND_CONDITIONS.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/shipping-and-refunding">Versand &amp; Rückgabe</Link>
            </li>
          </ul>
        </Col>
        <Col sm="4" className="text-left">
          <h5>{t(`FOOTER.HEAD2`)}</h5>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <p>
            12k. Support / tickettoaster
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <br />
            Tel.: +49 561 350 296 28 - 0<br />
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <a href="mailto:hallo@tickettoaster.de">hallo@tickettoaster.de</a>
          </p>
        </Col>
        <Col sm="4" className="text-left" />
        <Col className="mt-5 text-right">
          <a href="https://www.12k.de" target="_blank" rel="noopener noreferrer">
            <img
              src={require('./assets/images/zwoelfk_logo_typo.svg')}
              alt="12k."
              title="12k."
              width="250px"
              loading="lazy"
            />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default React.memo(Footer);
